import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import '../Styles/Components/AsanaStatusTag.scss';

export default function AsanaStatusTag(props) {



    var statusCircleClass = "AsanaStatusTag--Status-Circle";

    if (props.status === "Pending Review") {
        statusCircleClass = statusCircleClass + " PendingReview";
    } else if (props.status === "In Progress") {
        statusCircleClass = statusCircleClass + " InProgress";
    } else if (props.status === "Done") {
        statusCircleClass = statusCircleClass + " Done";
    } else if (props.status === "Abandoned") {
        statusCircleClass = statusCircleClass + " Abandoned";
    }

    return (
        <div className="AsanaStatusTag">

            <span className="AsanaStatusTag--Label">{props.title}</span>

            <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="AsanaStatusTag--Status-Tooltip" {...props}>{props.status}</Tooltip>}
            >
                <span className={statusCircleClass}></span>
            </OverlayTrigger>

        </div>
    )
}
